const Tag = ({ value, onClick }) => {
  // 2026
  return (
    <button
      className={`border px-3 py-1 rounded-full  dark:border-gray-600 font-semibold text-xs
        ${
          onClick
            ? "text-sky-600 border-sky-600 hover:bg-sky-100 active:bg-sky-700 active:text-white dark:active:text-gray-200 dark:hover:bg-gray-700 cursor-pointer"
            : "cursor-default"
        }
        `}
      onClick={onClick}
    >
      {value}
    </button>
  );
};

export default Tag;
